import axios from "axios";
import { showNotification } from "../actions/notificationActions";
import { store } from "../store";

axios.interceptors.response.use(
  function (response) {
    store.dispatch(showNotification(response.data));
    return response;
  },
  function (error) {
    const response = error && error.response;

    if (response && (response.status === 401 || response.data?.status === 401)) {
      window.location.href = "/login";
      return Promise.reject(error);
    }

    if (response && response.data) {
      store.dispatch(showNotification(response.data));
    }

    return Promise.reject(error);
  }
);
